import React, { useState, useEffect } from 'react';
import { experimentalStyled, useMediaQuery, Container, Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from './sidebar/Sidebar';
import Header from './header/Header';
import Footer from './footer/Footer';
import Customizer from './customizer/Customizer';
import { TopbarHeight } from '../../assets/global/Theme-variable';
import { getMyPermission } from '../../redux/slices/user-access.slice';
import { checkConfig, configure, loadLoggedUser } from '../../redux/slices/auth.slice';
import { useDispatch, useSelector } from "react-redux";
import UnauthorizedModal from '../../components/modal/UnauthorizedModal';
import { setPermissionModal, setSwitchMg, setSwitchMgAllowed } from '../../redux/slices/ui.slice';
import { set } from 'lodash';
import { IsPermessionGranted, IsUserPermessionGranted } from './sidebar/Menuitems';
import { getPublicListMagasin } from '../../redux/slices/magasin.slice';
import Storage from '../../services/Storage';


const MainWrapper = experimentalStyled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
  overflow: 'hidden',
  width: '100%',
}));
const PageWrapper = experimentalStyled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',

  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.up('lg')]: {
    paddingTop: TopbarHeight,
  },
  [theme.breakpoints.down('lg')]: {
    paddingTop: '64px',
  },
}));

const FullLayout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [isMobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const customizer = useSelector((state) => state.ui_store);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  
  const { loading, error, loggedUser } = useSelector(state => state.auth_store);
  //const [lst_menu, set_lst_menu] = useState([]);
  const [myclaims, set_myclaims] = useState(null);
  const [switch_mg, set_switch_mg] = useState(false);
  const [lst_mg, set_lst_mg] = useState([]);
  const [mg_config, set_mg_config] = useState(null);

  const dispatch = useDispatch()

  const load_permissions = () => {
    dispatch(getMyPermission()).unwrap().then(res => {
      console.log(res)
      if(Array.isArray(res)){
        set_myclaims(res)
        let tmp = IsUserPermessionGranted('changer_mg', 'changer_mg', res)
        set_switch_mg(tmp)
        dispatch(setSwitchMgAllowed(tmp));
      }
    }).catch(err => {
      console.log(err)
    })
  }

  const onSelectMg = (value) => {
    console.log(value)
        let token = Storage.getToken();
        dispatch(configure({ token: token, idMagasin: value?.idMagasin || 'all' }))
          .unwrap()
          .then((res) => {
            console.log(res);
             dispatch(setSwitchMg(value));
          }).catch((err) => console.log(err));
  };

  const onCheckConfig = (lst) => {
      dispatch(checkConfig())
        .unwrap()
        .then((res) => {
          console.log(res);
          set_mg_config(res);
          dispatch(setSwitchMg(lst.find(el => el?.idMagasin == res?.idMagasin)));
        })
        .catch((err) => {});
    };
  

  const load_magasin = () => {
      dispatch(getPublicListMagasin())
        .unwrap()
        .then((res) => {
          set_lst_mg(Array.isArray(res) ? res : []);
          onCheckConfig(Array.isArray(res) ? res : []);
        })
        .catch((err) => console.log(err));
    };

  const onCloseUnauthorizedModal = () => {
    dispatch(setPermissionModal(false));
  }



  useEffect(() => {
    dispatch(loadLoggedUser())
    load_magasin();
    load_permissions()
  }, [])


  return (
    <MainWrapper className={customizer?.activeMode === 'dark' ? 'darkbg' : ''}>
      <UnauthorizedModal show={customizer?.show_permission_modal} onClose={onCloseUnauthorizedModal} />
      <Header
        sx={{
          paddingLeft: isSidebarOpen && lgUp ? '265px' : '',
          backgroundColor: customizer?.activeMode === 'dark' ? '#20232a' : '#fafbfb',
        }}
        toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
        toggleMobileSidebar={() => setMobileSidebarOpen(true)}
        loggedUser={loggedUser}
        switch_mg={switch_mg}
        lst_mg={lst_mg}
        onSelectMg={onSelectMg}
        mg_config={mg_config}
      />

      <Sidebar
        lst_menu={myclaims}
        loggedUser={loggedUser}
        isSidebardir={customizer?.activeDir === 'ltr' ? 'left' : 'right'}
        isSidebarOpen={isSidebarOpen}
        isMobileSidebarOpen={isMobileSidebarOpen}
        onSidebarClose={() => setMobileSidebarOpen(false)}
      />

      <PageWrapper>
        <Container
          maxWidth={false}
          sx={{
            paddingTop: '20px',
            paddingLeft: isSidebarOpen && lgUp ? '280px!important' : '',
          }}
        >
          <Box sx={{ minHeight: 'calc(100vh - 170px)' }} id="main-container">
            <Outlet />
          </Box>
          {/* <Customizer />
          <Footer /> */}
        </Container>
      </PageWrapper>
    </MainWrapper>
  );
};

export default FullLayout;
